import { Component, OnInit } from '@angular/core';
import { FormGroup, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '@auth0/auth0-angular';
import { LoadingComponent } from "@digi-america/shared";
import { RequestCreateQuickQuote } from '../../types/dai-server/quotes/quote-requests';
import { Router } from '@angular/router';
import { QuoteService } from '../../services/quotes.service';
import { firstValueFrom } from 'rxjs';
import { FormGroupComponent } from "../product-editor/form-group.component";
import { PriceType } from '../../types/dai-server/quotes/enums';
import { ControlsOf } from '../../types/ControlsOf';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-quote-create-quick',
  imports: [FormGroupComponent, ReactiveFormsModule, LoadingComponent],
  templateUrl: './quote-create-quick.component.html',
  styleUrl: './quote-create-quick.component.scss',
  standalone: true
})
export class QuoteCreateQuickComponent implements OnInit {
  public form?: FormGroup<ControlsOf<RequestCreateQuickQuote>>;

  constructor(private fb: NonNullableFormBuilder, private router: Router, private quoteService: QuoteService, private userService: UserService, private auth: AuthService,) {
  }

  async ngOnInit(): Promise<void> {
    var user = await firstValueFrom(this.auth.user$);
    var profile = await firstValueFrom(this.userService.getProfile());

    this.form = this.fb.group({
      customer: this.fb.group({
        name: this.fb.control('', [Validators.required, Validators.maxLength(50)]),
        addressLine1: this.fb.control('', Validators.maxLength(50)),
        addressLine2: this.fb.control('', Validators.maxLength(50)),
        city: this.fb.control('', Validators.maxLength(50)),
        state: this.fb.control('', Validators.maxLength(50)),
        zip: this.fb.control('', Validators.maxLength(50)),
        phone: this.fb.control('', Validators.maxLength(50)),
        email: this.fb.control('', [Validators.maxLength(50), Validators.email]),
        pointOfContactName: this.fb.control('', Validators.maxLength(50)),
        pointOfContactTitle: this.fb.control('', Validators.maxLength(50)),
      }),
      salesRepresentative: this.fb.group({
        name: this.fb.control(user?.name || '', Validators.maxLength(50)),
        title: this.fb.control(profile.title ?? "", Validators.maxLength(50)),
        phoneNumber: this.fb.control(profile.phone ?? "", Validators.maxLength(50)),
        email: this.fb.control(user?.email || '', [Validators.maxLength(50), Validators.email]),
      }),
      useBillingForShipping: this.fb.control(true, Validators.required),
      shippingAddress: this.fb.group({
        name: this.fb.control('', Validators.maxLength(50)),
        addressLine1: this.fb.control('', Validators.maxLength(50)),
        addressLine2: this.fb.control('', Validators.maxLength(50)),
        city: this.fb.control('', Validators.maxLength(50)),
        state: this.fb.control('', Validators.maxLength(50)),
        zip: this.fb.control('', Validators.maxLength(50)),
      }),
      priceType: this.fb.control(PriceType.list, Validators.required),
    });

    this.form.controls.customer
  }

  async submit() {
    if (this.form) {
      const data: RequestCreateQuickQuote = this.form.getRawValue();
      const result = await firstValueFrom(this.quoteService.createQuickQuote(data));
      this.router.navigate(['/', 'quote-view', result.id]);
    }
  }
}
